const callbacks = {};
let registered = false;

// Detect app run inside mobile app
export function mobileRegister() {
  if (!isRunInsideIFrame() || registered) {
    return;
  }
  registered = true;
  sendActionToMobileApp({ action: 'checkMobileApp' }, () => {
    window.isMobileApp = true;
    checkIosLatestVersion();
  });

  // Listen message from ios app
  window.addEventListener('message', function (event) {
    var message = event.data || {};
    if (message.from === 'com.exirio.app') {
      if (callbacks[message.callbackId]) {
        try {
          callbacks[message.callbackId](message.response);
        } catch (e) {
          console.warn('Error', e);
        }
        delete callbacks[message.callbackId];
      }
    }
  });
}

// Can remove this function after next release prod after 4.40>
function checkIosLatestVersion() {
  const isDevSite = window.location.hostname === 'ui-dev.exirio-dev.com';
  if (isDevSite) {
    promptUpdateIosVersion();
  } else {
    checkIosUsingAutoUpdate();
  }
}

function checkIosUsingAutoUpdate() {
  const timer = setTimeout(() => promptUpdateIosVersion(), 2000);
  sendActionToMobileApp({ action: 'getAppVersion' }, (data) => {
    console.log('Ok', data);
    clearTimeout(timer);
  });
}

function promptUpdateIosVersion() {
  alert('The new version available! Ready to update?');

  // Open browser navigate to appstore for user update exirio app
  mobileLoginBrowser('itms-apps://apps.apple.com/app/exirio/id1560263435', '', () => {
    console.log('Opened exirio on AppStore');
  });
}

export function isMobileApp() {
  return (isRunInsideIFrame() && registered) || window.cordova;
}

export function mobileLoginGoogle(url, callback) {
  if (window.cordova) {
    window.AppAuthProvider.withGoogle(url, callback);
    return;
  }
  const message = {
    action: 'signinGoogle',
    url: url,
  };
  sendActionToMobileApp(message, callback);
}

export function mobileLoginApple(url, callback) {
  if (window.cordova) {
    window.AppAuthProvider.withApple(url, callback);
    return;
  }
  const message = {
    action: 'signinApple',
    url: url,
  };
  sendActionToMobileApp(message, callback);
}

export function mobileLoginBrowser(url, callbackUrl, callback) {
  if (window.cordova) {
    window.AppAuthProvider.withBrowser(url, callbackUrl, callback);
    return;
  }
  const message = {
    action: 'signinBrowser',
    url: url,
    callbackUrl: callbackUrl,
  };
  sendActionToMobileApp(message, callback);
}

export function isRunInsideIFrame() {
  return window.parent !== window;
}

function sendActionToMobileApp(data, callback) {
  data.callbackId = new Date().getTime();
  callbacks[data.callbackId] = callback;
  window.parent.postMessage(data, '*');
}
